export default __webpack_public_path__ + "static/media/nikhil3.5dd62cd2.jpg";